/**
 * Stable, collision-resistant identifiers for domain entities.
 * We avoid `crypto.randomUUID()` as the sole path because it is unavailable
 * on insecure origins in some browsers; a seeded fallback keeps the DAW usable.
 */

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';

function randomBytes(length: number): Uint8Array {
  const out = new Uint8Array(length);
  const g: Crypto | undefined = typeof globalThis.crypto !== 'undefined' ? globalThis.crypto : undefined;
  if (g && typeof g.getRandomValues === 'function') {
    g.getRandomValues(out);
    return out;
  }
  for (let i = 0; i < length; i++) out[i] = Math.floor(Math.random() * 256);
  return out;
}

/** Create a prefixed, URL-safe, 16-char random id, e.g. `trk_9f3k2m...`. */
export function createId(prefix: string): string {
  const bytes = randomBytes(12);
  let s = '';
  for (let i = 0; i < bytes.length; i++) s += ALPHABET[bytes[i] % ALPHABET.length];
  return `${prefix}_${s}`;
}

export const newProjectId = (): string => createId('prj');
export const newTrackId = (): string => createId('trk');
export const newClipId = (): string => createId('clp');
export const newAssetId = (): string => createId('ast');
export const newNoteId = (): string => createId('not');
export const newEffectId = (): string => createId('fx');
export const newSendId = (): string => createId('snd');
export const newLaneId = (): string => createId('lan');
export const newPointId = (): string => createId('pnt');
export const newMarkerId = (): string => createId('mrk');
export const newTakeId = (): string => createId('tak');
export const newWarpMarkerId = (): string => createId('wrp');
export const newGainPointId = (): string => createId('gan');
